import { makeStyles } from '@mui/styles';
const financeSummaryStyles = makeStyles(() => ({
    container: {},
}), {
    name: 'Common_FinanceSummary',
});
export default financeSummaryStyles;
//# sourceMappingURL=financeSummary.styles.js.map